import { gt } from 'lodash-es';
import {
  getPageOrDefault,
  DEFAULT_NO_OF_ITEMS as DEFAULT_NO_OF_ELEMENTS_PER_PAGE,
  MAX_PAGE as MAX_PAGINATION_ELEMENTS,
} from '@is24at/react-pagination';
import { SearchParamsEnum } from 'utils/enums';
import canonicalUrl from './canonicalUrl';

const next = ({ searchQuery = {}, pathname, totalHits }: any = {}) => {
  const page = getPageOrDefault(searchQuery);
  const hasMorePages = gt(totalHits, DEFAULT_NO_OF_ELEMENTS_PER_PAGE * page);
  const notTheLastPage = MAX_PAGINATION_ELEMENTS !== page;
  return hasMorePages && notTheLastPage
    ? canonicalUrl({
        searchQuery: {
          ...searchQuery,
          [SearchParamsEnum.page]: page + 1,
        },
        pathname,
      })
    : undefined;
};

export default next;
